function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.078 1.943c-.584 0-1.058.438-1.058.98v10.155c0 .54.474.979 1.058.979h7.844c.584 0 1.058-.438 1.058-.98V6.125a.245.245 0 00-.08-.18L8.654 2.018a.286.286 0 00-.195-.074H4.08zM2 2.923C2 1.86 2.93 1 4.078 1H8.46c.344 0 .673.126.916.35l4.246 3.928c.243.224.379.529.379.846v6.954C14 14.139 13.07 15 11.922 15H4.078C2.931 15 2 14.14 2 13.078V2.922zM5.137 8c0-.26.229-.471.51-.471h4.706c.281 0 .51.21.51.471 0 .26-.229.472-.51.472H5.647c-.282 0-.51-.212-.51-.472zm0 2.902c0-.26.229-.472.51-.472h4.706c.281 0 .51.211.51.472 0 .26-.229.471-.51.471H5.647c-.282 0-.51-.211-.51-.471z",
  fill: "#2D2D2D"
});
function SvgDocumentos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Documentos.svg";
export { SvgDocumentos as ReactComponent };